<template>
  <div class="home">
    <!-- header with background image -->
    <header>
      <div class="header-info">
        <h1>Nigeria's Reliable and Innovative Entrepreneurial Platform</h1>
        <br />
        <div class="buttons">
          <router-link class="btn btn-light" to="/services"
            >Learn more</router-link
          >
          <router-link class="btn btn-outline" to="/about"
            >About us</router-link
          >
        </div>
      </div>
    </header>
    <!-- intro section -->
    <section class="one">
      <!-- info panel 1 -->
      <div class="info-panel">
        <h2>Who we are</h2>
        <p>
          We are Nigeria’s foremost entrepreneurial platform that offers a one
          stop shop for all the needs of entrepreneurs in order to help them
          successfully grow their businesses in the ever changing Nigerian
          economic environment. Our vision is to Connect Entrepreneurs with all
          the resources they need to succeed in the most innovative and
          professional means while we are poised to achieve our mission which is
          to continually improve in making our services Valuable, Unique, Easy
          and Accessible to all our esteemed clients
        </p>
        <br />
        <router-link class="btn btn-dark" to="/about">Learn more</router-link>
      </div>
      <!-- image panel 1 -->
      <div class="img-panel-1">
        <img :src="require('@/assets/1_half.png')" height="300px" alt="" />
      </div>
      <!-- image panel 2 -->
      <div class="img-panel-2">
        <img :src="require('@/assets/2_half.png')" height="300px" alt="" />
      </div>
      <!-- info panel 2 -->
      <div class="info-panel">
        <h2>What we do</h2>
        <p>
          At CSVC, your raw idea and your dreams of being a successful business
          owner becomes a reality as we help you legalize, brand, structure,
          draft your business plan, fund and manage your idea in order to turn
          same into a successful business. As an already established business,
          our wide range of services covering Funding , Ventures Management ,
          Training , SME toolkits , Business Branding have been proven to add
          great value in ensuring you record greater successes and milestones.
          CSVC also operates
          <a href="http://www.connectskills.com.ng" class=""
            >www.connectskills.com.ng</a
          >, an online service directory where you can find skilled
          entrepreneurs at no cost. You can also sign up here and register as a
          service provider absolutely free.
        </p>
        <br />
        <a
          href="#"
          class="btn btn-dark"
          style="margin-right:1rem"
          @click="$router.push({ name: 'services' })"
          >See all our services</a
        >
        <!-- <a href="http://www.connectskills.com.ng" class="btn btn-outline-dark">Visit our service directory </a> -->
      </div>
    </section>
    <!-- what makes us -->
    <div class="inter">
      <h1>Why Choose us</h1>
    </div>
    <section class="two">
      <div v-for="c in choices" :key="c.id" class="card">
        <img
          :src="require('@/assets/' + c.img)"
          height="150px"
          width="150px"
          alt=""
        />
        <h3>{{ c.title }}</h3>
        <p>{{ c.text }}</p>
      </div>
    </section>
    <!-- contact form-->
    <section id="contact" class="three">
      <h1>Contact us today</h1>
      <form
        class="contact"
        action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSd4L2Ic2-KV0qorHVRM-z_Q9-_sZM5MX9gyMjMCPzUYw1jEPg/formResponse"
      >
        <div class="form-control one">
          <input
            aria-label="Full name"
            type="text"
            name="entry.1555682170"
            placeholder="Full name"
            required
          />
          <label for="entry.15556821701">Full name</label>
        </div>

        <div class="form-control two">
          <input
            aria-label="Phone number"
            type="text"
            name="entry.1609538826"
            placeholder="Phone number"
            required
          />
          <label for="entry.1609538826">Phone Number</label>
        </div>

        <div class="form-control one">
          <input
            aria-label="Email address"
            type="email"
            name="entry.803355984"
            placeholder="Email address"
          />
          <label for="entry.803355984">Email address</label>
        </div>

        <div class="form-control two">
          <input
            aria-label="Residential State"
            type="text"
            name="entry.2066710611"
            placeholder="State"
          />
          <label for="entry.2066710611">State</label>
        </div>

        <div class="form-control full">
          <textarea
            placeholder="Enter message..."
            name="entry.1997180777"
            required
            rows="5"
          >
          </textarea>
          <label for="entry.1997180777">Enter message</label>
        </div>

        <button class="btn btn-dark" type="submit">Send message</button>
      </form>
    </section>
  </div>
</template>

<style scoped>
/***************** HEADER STYLES ************/
header {
  height: 40vh;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  background: url("/header_bg.jpg");
  background-position: top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  justify-content: center;
}
header h1 {
  font-style: lighter;
  color: whitesmoke;
}
header .buttons {
  display: inline;
}
a.btn-light {
  margin-right: 1.5rem;
}
/************ SECTION 1 ************/
section.one {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
section.one .info-panel {
  grid-column: span 3;
  margin: 2rem;
}
.info-panel a {
  text-decoration: none;
}
section.one .img-panel-1 {
  grid-column: span 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
section.one .img-panel-2 {
  grid-column: span 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
/* section.one break-point */
@media only screen and (max-width: 998px) {
  section.one .info-panel {
    grid-column: span 4;
  }
  section.one .img-panel-1 {
    grid-column: 1/3;
  }
  section.one .img-panel-2 {
    grid-column: 3/5;
  }

  section.one .img-panel-1 img,
  .img-panel-2 img {
    height: 50vw;
  }
}

div.inter {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

/*********** SECTION TWO ********/
section.two {
  margin: 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
}
section.two .card {
  text-align: center;
  grid-column: span 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  border-radius: 1.5rem;
  height: 250px;
  box-shadow: 2px 8px 30px lightgrey;
}
@media only screen and (max-width: 480px) {
  section.two .card {
    grid-column: span 3;
  }
}

section.three {
  padding: 1rem;
  margin-top: 2rem;
  background: rgb(159, 187, 245);
}
/******** FORM STYLES ************/
form.contact {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
form.contact label {
  font-size: 12px;
  margin-bottom: 0.5rem;
}
form.contact input,
textarea {
  border-radius: 1rem;
  padding: 0.5rem;
  border-style: solid;
}
form.contact .form-control {
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 0.25rem;
}
form.contact .form-control.one {
  grid-column: 1/2;
}
form.contact .form-control.two {
  grid-column: 2/3;
}
form.contact .form-control.full {
  grid-column: 1/3;
}

form.contact button {
  display: block;
}

/* form media queries */
@media only screen and (max-width: 998px) {
  form.contact .form-control.two {
    grid-column: 1/3;
  }
  form.contact .form-control.one {
    grid-column: 1/3;
  }
}

/******** BUTTONS  *********/
.buttons a {
  text-decoration: none;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    // HelloWorld
  },
  data() {
    return {
      choices: [
        {
          img: "empower.png",
          title: "We empower SMEs",
          text: "Commited to empowering entrepreneurs"
        },
        {
          img: "innovate.png",
          title: "We are innovative",
          text: "We provide innovative and leading solutions"
        },
        {
          img: "reliable.png",
          title: "We are reliable",
          text: "You are 100% assured that you can rely on us"
        }
      ]
    };
  }
};
</script>
